// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import Joi from 'joi'

import { EntityConstants, TELEPHONE_NUMBER_PATTERN_REGEX } from 'constants/index'


const messages = {
  'string.base': 'Field must be a string',
  'string.email': 'Invalid email format',
  'string.max': `Field must be at most {#limit} characters`,
  'string.pattern.base': 'Please enter a valid phone number',
}

function validationSchema() {
  return Joi.object({
    firstName: Joi.string()
      .required()
      .max(EntityConstants.MAX_FIRST_NAME_LENGTH)
      .messages(messages),
    lastName: Joi.string().required().max(EntityConstants.MAX_FIRST_NAME_LENGTH).messages(messages),
    email: Joi.string()
      .email({ tlds: { allow: false } })
      .required()
      .max(EntityConstants.MAX_ADDRESS_LENGTH)
      .messages(messages),
    telephoneNumber: Joi.string()
      .required()
      .pattern(new RegExp(TELEPHONE_NUMBER_PATTERN_REGEX))
      .max(EntityConstants.MAX_TELEPHONE_NUMBER_LENGTH)
      .messages(messages),
    isActive: Joi.boolean().allow(null, '').optional(),
    role: Joi.string().optional(),
  })
}

export default validationSchema
